// TLA product parent-map (arch doc §4.9). Product-agnostic core consumes this;
// other products (JCEOS/JCTI) ship their own. Verified against the route table in
// frontend/src/App.js. Every labelKey requires en/de/es entries (es via backend).
// Deep/param routes not literally present fall through to the matcher (strip last
// segment and retry), else land on the role dashboard.
export const parentMapTLA = {
  '/': { parent: null, labelKey: 'nav.home' },

  // Public discovery
  '/listings': { parent: '/', labelKey: 'nav.listings' },
  '/listings/:listingId': {
    parent: '/listings',
    labelKey: 'nav.listingDetail',
    resolveLabel: (params, data) => (data && data.title) || null,
    fallbackKey: 'experience.breadcrumb.listing',
  },
  '/locations': { parent: '/', labelKey: 'nav.locations' },
  '/locations/:locationId': { parent: '/locations', labelKey: 'nav.locationDetail' },
  '/neighborhood/:locationId': { parent: '/locations', labelKey: 'nav.neighborhoodGuide' },
  '/pricing': { parent: '/', labelKey: 'nav.pricing' },
  '/tla-calculator': { parent: '/pricing', labelKey: 'nav.tlaCalculator' },
  '/insurance': { parent: '/', labelKey: 'nav.insurance' },
  '/rental-cars': { parent: '/', labelKey: 'nav.rentalCars' },
  '/pcs-checklist': { parent: '/', labelKey: 'nav.pcsChecklist' },
  '/local-favorites': { parent: '/', labelKey: 'nav.localFavorites' },
  '/phrases': { parent: '/', labelKey: 'nav.phrases' },
  '/phrases/:languageCode': { parent: '/phrases', labelKey: 'nav.languagePhrases' },
  '/faq': { parent: '/', labelKey: 'nav.faq' },
  '/about': { parent: '/', labelKey: 'nav.about' },
  '/contact': { parent: '/', labelKey: 'nav.contact' },
  '/privacy': { parent: '/', labelKey: 'nav.privacy' },
  '/terms': { parent: '/', labelKey: 'nav.terms' },
  '/imprint': { parent: '/', labelKey: 'nav.imprint' },

  // AI / assistive
  '/concierge': { parent: '/', labelKey: 'nav.concierge' },
  '/location-match': { parent: '/', labelKey: 'nav.locationMatch' },

  // User / guest (parent = user dashboard)
  '/dashboard': { parent: '/', labelKey: 'nav.dashboard' },
  '/favorites': { parent: '/dashboard', labelKey: 'nav.favorites' },
  '/compare': { parent: '/listings', labelKey: 'nav.compare' },
  '/bookings': { parent: '/dashboard', labelKey: 'nav.bookings' },
  '/notifications': { parent: '/dashboard', labelKey: 'nav.notifications' },
  '/journey': { parent: '/dashboard', labelKey: 'nav.lifeJourney' },
  '/settings': { parent: '/dashboard', labelKey: 'nav.settings' },

  // Owner (parent = owner dashboard)
  '/owner/dashboard': { parent: '/', labelKey: 'nav.ownerDashboard' },
  '/owner/listings': { parent: '/owner/dashboard', labelKey: 'nav.ownerListings' },
  '/owner/listings/new': { parent: '/owner/listings', labelKey: 'nav.ownerListingNew' },
  '/owner/listings/:listingId/edit': { parent: '/owner/listings', labelKey: 'nav.ownerListingEdit' },
  '/owner/plans': { parent: '/owner/dashboard', labelKey: 'nav.ownerPlans' },

  // Admin
  '/admin': { parent: '/', labelKey: 'nav.adminDashboard' },
};
